import styled from "styled-components";
import { SlideshowIcon } from "./Icon";
import React from "react";

const Container = styled.div`
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1024px) {
    width: 100%;
    height: 100vh;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  p {
    font-size: 1.5rem;
    font-weight: bold;
    color: black;
    height: 3rem;
    line-height: 3rem;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

const SubTitle = styled.p`
  color: gray;
  padding-left: 4rem;
  @media (max-width: 1024px) {
    padding: 0;
  }
`;

const Icon = styled.div`
  width: 3rem;
  height: 3rem;
  margin-right: 1rem;
  @media (max-width: 1024px) {
    margin: 0;
  }
`;

const LeftContainer = props => {
  return (
    <Container>
      <Content>
        <Title>
          <Icon>
            <SlideshowIcon />
          </Icon>
          <p>Simple Carousel</p>
        </Title>
        <SubTitle>A simple react carousel with infinite loop</SubTitle>
      </Content>
    </Container>
  );
};

export default LeftContainer;
